import React, { useState } from 'react'
import { CameraDesc } from './CameraDesc'
import { CameraStyle, CameraStatus } from './style'

export const Cameras = ({ camName, isOk = false, videoPath }) => {
    const [isOpen, setIsOpen] = useState(false)

    const onToggle = (e) => {
        if (e.target.closest(".camera_preview")) {
            setIsOpen(!isOpen);
        }
    }

    return (
        <CameraStyle className="mtn brs fade-in" onClick={onToggle}>
            <div className="df camera_preview brs">
                <div className="df">
                    <CameraStatus ok={isOk} />
                    <img src="./img/icons/camera.svg" alt="camera" className="icon mla filinv" style={{marginLeft: "10px"}} />
                </div>
                <div className="fs-n cedit">{camName}</div>
                <div className="df mla">
                    <div className="fs-n">234</div>
                    <img src="./img/icons/group.svg" alt="people" className="icon filinv" style={{marginLeft: "10px"}} />
                </div>
                <div className="fs-n ">28:34</div>
                <img src="./img/icons/refresh.svg" alt="refresh" className="icon button_icon filinv" />
                <img src="./img/icons/delete.svg" alt="delete" className="icon button_icon" />
            </div>
            {isOpen &&
                <CameraDesc videoPath={videoPath} />
            }
        </CameraStyle>
)
}